var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 1.00269C7.73137 1.00269 1.01562 7.71837 1.01562 16.0027C1.01562 24.287 7.73137 31.0027 16.0156 31.0027C24.2999 31.0027 31.0156 24.2869 31.0156 16.0027C31.0156 7.71844 24.3 1.00269 16.0156 1.00269ZM25.208 25.1951C22.9286 27.4676 19.8848 28.81 16.6696 28.9609C13.4545 29.1117 10.2983 28.0601 7.81613 26.011C5.33397 23.9619 3.70361 21.0621 3.24272 17.8766C2.78184 14.691 3.52345 11.448 5.32305 8.77944C7.12266 6.11085 9.85134 4.20784 12.9774 3.44123C16.1035 2.67462 19.403 3.09932 22.233 4.63258C25.063 6.16584 27.2209 8.69781 28.286 11.7351C29.3512 14.7725 29.2474 18.0976 27.9948 21.0626C27.342 22.6074 26.3956 24.0108 25.208 25.1951Z",
    fill: "#14FFEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9773 10.3116L19.6681 15.0025H8.00858V17.0025H19.6681L14.9773 21.6934L16.3915 23.1076L23.4966 16.0025L16.3915 8.89746L14.9773 10.3116Z",
    fill: "#14FFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrow);
export default __webpack_public_path__ + "static/media/pagination-arrow.178c9e026e96d3157c68aa003413b7a7.svg";
export { ForwardRef as ReactComponent };